import React from 'react';
import { AccordionRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRuleHeader';
import { useGetDurationsSubheader } from './hooks/useGetDurationsSubheader';

export interface DurationsRuleHeaderProps {
  isActive: boolean;
}

export function DurationsRuleHeader({
  isActive,
}: DurationsRuleHeaderProps): JSX.Element {
  const { subheader } = useGetDurationsSubheader();

  return (
    <AccordionRuleHeader
      showSubheader={!isActive}
      header="Date and time settings"
      subheader={subheader}
    />
  );
}
